import { render, staticRenderFns } from "./DialogServiceManager.vue?vue&type=template&id=543b7dbe"
import script from "./DialogServiceManager.vue?vue&type=script&lang=js"
export * from "./DialogServiceManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports